export enum FeatureGates {
  InternalCompanyTreatment = 'internal_company_treatment',
  EnablePDF = 'enable_tutorial_pdf',
  EnableLTA = 'enable-lta',
  EnableLTAActions = 'enable-lta-actions',
  EnableLTAEmployerRequestCallouts = 'enable-lta-employer-request-callouts',
  EnableUpdateNotification = 'enable_biz_portal_update_notification',
  EnableProp22ShiftEditorAffirmation = 'enable_prop_22_shift_editor_affirmation',
  EnableActionBarV2 = 'enable_action_bar_v2',
  EnableOnDemandDeliveryShiftCreation = 'enable_on_demand_delivery_shift_creation',
  EnableReviewEvaluateV2 = 'enable_review_evaluate_v2',
  EnableUpcomingInvoices = 'enable_upcoming_invoices',
  EnableW2LeadPositions = 'enable_w2_lead_positions',
  EnableShiftCustomFields = 'enable_shift_custom_fields',
}

export enum DynamicConfigName {
  ShiftLeadCreationHospitality = 'shift_lead_creation_hospitality',
  ShiftLeadMinWorkers = 'shift_lead_min_workers',
  EnableTipsInTheBusinessPortal = 'enable_tips_in_the_business_portal',
}
